/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var MailslurpDomainNames;
(function (MailslurpDomainNames) {
    MailslurpDomainNames["FMTFOODS_COM"] = "fmtfoods.com";
    MailslurpDomainNames["FMTFOODS_NET"] = "fmtfoods.net";
    MailslurpDomainNames["FMTFOODSUSA_COM"] = "fmtfoodsusa.com";
    MailslurpDomainNames["FULLMEALS_APP"] = "fullmeals.app";
    MailslurpDomainNames["FULLMEALS_XYZ"] = "fullmeals.xyz";
    MailslurpDomainNames["GOCRUMBL_COM"] = "gocrumbl.com";
    MailslurpDomainNames["LOOPAPPLICATION_XYZ"] = "loopapplication.xyz";
    MailslurpDomainNames["TEAMAPRIO_COM"] = "teamaprio.com";
    MailslurpDomainNames["TEAMAPRIOUSA_COM"] = "teamapriousa.com";
    MailslurpDomainNames["WHATABURGERFOODS_COM"] = "whataburgerfoods.com";
})(MailslurpDomainNames || (MailslurpDomainNames = {}));
